module.exports = __webpack_public_path__ + "static/media/declinedRequestsIcon.209a9ad7.svg";